import React from 'react';

import { createStyles, WithStyles, withStyles } from '@material-ui/core';

import { TypographyWithIcon, TypographyWithIconProps } from './TypographyWithIcon';

const styles = () =>
  createStyles({
    icon: {
      maxWidth: 20,
    },
  });

export interface TypographyWithWarningProps
  extends Omit<TypographyWithIconProps, 'classes' | 'icon'>,
    WithStyles<typeof styles> {}

const TypographyWithWarningComponent: React.FC<TypographyWithWarningProps> = ({ classes, ...rest }) => (
  <TypographyWithIcon
    icon={
      <span className={classes.icon} role="img" aria-label="warning">
        ⚠️
      </span>
    }
    {...rest}
  />
);

export const TypographyWithWarning = withStyles(styles)(TypographyWithWarningComponent);
